export default __webpack_public_path__ + "78daf7e4855cd2ab91fda9770e442483.svg";